'use strict';

var _extends = require('../../../node_modules/@babel/runtime/helpers/extends.js');
var defineProperty = require('../../../node_modules/@babel/runtime/helpers/defineProperty.js');
var objectWithoutProperties = require('../../../node_modules/@babel/runtime/helpers/objectWithoutProperties.js');
var React = require('react');
var ListSubheader = require('../../../node_modules/@material-ui/core/esm/ListSubheader/ListSubheader.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var ListExplanationText = function ListExplanationText(_ref) {
  var style = _ref.style,
      restOfProps = objectWithoutProperties(_ref, ["style"]);

  return React__default["default"].createElement(ListSubheader["default"], _extends["default"]({}, restOfProps, {
    style: _objectSpread({
      fontSize: '13px',
      lineHeight: '24px',
      marginTop: 0,
      fontWeight: 400,
      fontStyle: 'italic',
      color: 'rgba(0, 0, 0, 0.38)'
    }, style)
  }));
};

module.exports = ListExplanationText;
